import clsx from "clsx";
import type React from "react";
import styles from "./Kbd.module.scss";

export interface KbdProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
}

/** A keyboard key, such as `Esc` or `⌘`. Render one per key; put combinations side by side. */
const Kbd = (props: KbdProps) => {
  const { children, className, ...otherProps } = props;
  return (
    <kbd className={clsx(styles.kbd, className)} {...otherProps}>
      {children}
    </kbd>
  );
};

export default Kbd;
